<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{period}}</h4>
                <p style="font-size: 12px">{{current_datetime}}h</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-clock-o fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{raft_level}} %</h4>
                <p style="font-size: 12px">{{web_texts.partials.raft_level}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-reorder fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{cabdal}} m<sup>3</sup>/h</h4>
                <p style="font-size: 12px">{{web_texts.partials.cabdal}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-compass fa-4x card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{pump_status}}</h4>
                <p style="font-size: 12px">{{web_texts.partials.pump_status}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.shuntings}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">

            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-share font-2xl"></i>
                <span class="px-2">{{web_texts.partials.start_mode}}</span>
              </div>
              <button v-if="contactor_status==='ON'" class="btn col-md-5 btn-warning btn-lg btn-block" disabled>ON
              </button>
              <button v-else-if="contactor_status==='OFF'" type="button"
                      class="btn col-md-5 btn-danger btn-lg btn-block" disabled>OFF
              </button>
              <button v-else-if="contactor_status==='AUTO'" type="button"
                      class="btn col-md-5 btn-success btn-lg btn-block" disabled>AUTO
              </button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
            <br>
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-shuffle font-2xl"></i>
                <span class="px-2">{{web_texts.partials.physical_selector}}</span>
              </div>
              <button v-if="selector_status==='AUTO'" class="btn col-md-5 btn-success btn-lg btn-block" @click="onOffPump('AUTO')">
                AUTO
              </button>
              <button v-else-if="selector_status==='MAN'" class="btn col-md-5 btn-success btn-lg btn-block" @click="onOffPump('MAN')">
                MAN
              </button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
            <br>
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-flag font-2xl"></i>
                <span class="px-2">{{web_texts.partials.pump_status}}</span>
              </div>
              <button v-if="pump_status==='OFF'" class="btn col-md-5 btn-danger btn-lg btn-block" disabled>OFF</button>
              <button v-else-if="pump_status==='ON'" type="button" class="btn col-md-5 btn-success btn-lg btn-block"
                      disabled>ON
              </button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>
            <br>
            <div class="row">
              <div class="col-md-7" style="margin-top: 13px">
                <i class="icon-control-end font-2xl"></i>
                <span class="px-2">{{web_texts.partials.shunting}}</span>
              </div>
              <button v-if="pump_status==='OFF'" class="btn col-md-5 btn-warning btn-lg btn-block" @click="onOffPump('ON_pump')" disabled>
                ON
              </button>
              <button v-else-if="pump_status==='ON'" type="button" class="btn col-md-5 btn-warning btn-lg btn-block" @click="onOffPump('OFF_pump')" disabled>
                OFF
              </button>
              <button v-else="" class="btn col-md-5 btn-default btn-lg btn-block" disabled>S/D</button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.historical_shunting}}</strong>
          </div>
          <div class="card-block" style="min-height: 352px">
            <vue-good-table :columns="columns" :rows="list_events" :paginate="true" :perPage="4"
                            :defaultSortBy="{field: 'date', type: 'desc'}">
              <template slot="table-row" scope="props">
                <td :class="props.row.value">{{ props.row.date }}</td>
                <td :class="props.row.value">{{ props.row.shunter }}</td>
                <td :class="props.row.value">{{ props.row.value }}</td>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <strong>{{web_texts.partials.historical_raft_level}}</strong>
          </div>
          <div class="card-block">
            <div id="perc-aigua-bassa" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Shuntting';
  import trans_es from '../../../translates/es/Shuntting';
  import constants from '../../../constants';
  import middleware from '../../../utilities/middlewares';
  import dateRanges from '../../../utilities/dates_intervals';
  import dataTransforms from '../../../utilities/data_transformers';

  export default {
    name: 'PumpShunting',
    data() {
      return {
        web_texts: { "generator": "Grup Electrogen", "pump": "Bomba-Bassa", "diffs": "Magnetos-Diferencials", "partials": { "raft_level": "Nivell Bassa", "cabdal": "Cabal Aigua", "pump_status": "Estat Bomba", "shuntings": "Maniobres", "start_mode": "Mode d\'arranc", "physical_selector": "Selector fisic", "shunting": "Maniobra", "historical_shunting": "Històric maniobres", "historical_raft_level": "Històric nivell bassa", "contracted_power": "Pot. Contractada", "general_power": "Pot. General", "generator_power": "Pot. Grup", "shunting_status": "Estat Maniobra", "selector_status": "Estat Selector", "contactor_status": "Estat Contactor", "net_supply": "XARXA", "generator": "GRUP", "generator_status": "Estat Grup", "emergency_stop": "Parada d\'emergència", "deactivated": "DESACTIVAT", "compare_powers": "Comparativa Pot. General - Pot. Grup", "mag_diff_well": "Mag/Dif Pou", "mag_diff_raft": "Mag/Dif Bassa", "status": "Estat" } },
        period: 'S/D',
        current_datetime: 'S/D',
        raft_level: 'S/D',
        class_card_color: 'card-success',
        cabdal: '0',
        pump_status: 'S/D',
        selector_status: 'S/D',
        contactor_status: 'S/D',
        meter_lecture: 'S/D',
        list_events: [],
        columns: [
          {
            label: 'Data',
            field: 'date',
            type: 'date',
            inputFormat: 'DD/MM/YYYY HH:mm:ss',
            width: '180px',
            html: true
          },
          {
            label: 'Dispositiu',
            field: 'shunter',
            html: true
          },
          {
            label: 'Estat',
            field: 'value',
            html: true
          }
        ]
      }
    },
    created() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["shunt","pump_shunt"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      var out = this;

      this.system = JSON.parse(window.localStorage.getItem('system'));

      console.log("Created pump Shunt");
      this.current_datetime = dateRanges.getCurrentDateTime();
      this.getMasterEventsPumpRT(JSON.parse(window.localStorage.getItem('masters')));
      this.getPumpEvents(JSON.parse(window.localStorage.getItem('masters')));
      this.getHeadCardsInfo();

      var merter_lec_arr = 0;
      var cabal_interval = null;
      setTimeout(function () {
        merter_lec_arr = out.meter_lecture;
        cabal_interval = setInterval(function () {
          if (out.meter_lecture !== 'S/D') {
            if (out.pump_status === "ON") {
              out.cabal = (((out.meter_lecture - merter_lec_arr) / 10) * 360);

              merter_lec_arr = out.meter_lecture;
            } else {
              out.cabal = 0;
            }
          }
        }, 10000);
      }, 1500);

      var pump_shunt_interval = setInterval(function () {
        console.log("Interval pump Shunt");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
        if (contr_rt[1] !== "pump_shunt") {
          console.log("Clear pump Shunt");
          clearInterval(pump_shunt_interval);
          clearInterval(cabal_interval);
        } else {
          out.current_datetime = dateRanges.getCurrentDateTime();
          var master = JSON.parse(window.localStorage.getItem('masters'));
          out.getMasterEventsPumpRT(master);
          out.getPumpEvents(master);
          out.getHeadCardsInfo();
        }
      }, 5000);
    },
    mounted() {
      this.getMonthlyWellPercLevel(JSON.parse(window.localStorage.getItem('masters')));
      this.getEventsPump();
    },
    methods: {
      //  Llegir periode per a les cards (esta dins del interval)
      getHeadCardsInfo() {
        axios.post(constants.ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.period = response.data.period;
        }, (response) => {
          console.log(response);
        });
      },
      //  Llegir els events (esta dins del interval)
      getMasterEventsPumpRT(masters) {
        var master_id = masters[0].id;
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[master_id, "R$CAL_LecturaComptador.M3", "R$CAL_NivellBassa.PERC"]])
        }).then((response) => {
          if (response.data[0].value !== '-') {
            this.meter_lecture = Math.round(parseFloat(response.data[0].value) * 100) / 100;
          } else {
            this.meter_lecture = "S/D";
          }
          if (response.data[1].value !== '-') {
            this.raft_level = Math.round(parseFloat(response.data[1].value) * 100) / 100;
          } else {
            this.raft_level = "S/D";
          }
        }, (response) => {
          console.log(response.data);
        });
      },
      //  Llegir els events de les bombes (esta dins del interval)
      getPumpEvents(masters) {
        var master_id = masters[0].id;
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: '[["' + master_id + '", "R$EVE_E_Bomba_ON.ST", "R$EVE_E_Bomba_OFF.ST", "R$EVE_Selector_ON.ST", "R$EVE_Selector_OFF.ST", "R$EVE_Selector_AUT.ST" ,"R$EVE_APP_Bomba_Poweroff_AUT.ST"]]'
        }).then((response) => {
          if (parseInt(response.data[0].value) === 1) {
            this.pump_status = "ON";
          } else if (parseInt(response.data[1].value) === 1) {
            this.pump_status = "OFF";
          } else {
            this.pump_status = "S/D";
          }

          console.log(response.data);

          if (parseInt(response.data[2].value) === 1) {
            this.contactor_status = "ON";
          } else if (parseInt(response.data[3].value) === 1) {
            this.contactor_status = "OFF";
          } else if (parseInt(response.data[4].value) === 1) {
            this.contactor_status = "AUTO";
          } else {
            this.contactor_status = "S/D";
          }

          if (parseInt(response.data[5].value) === 0) {
            this.selector_status = "AUTO";
          } else {
            this.selector_status = "MAN";
          }
        }, (response) => {
          console.log(response)
        });
      },
      // Llegir event de les bombes per a veure si estan engegades
      getEventsPump() {
        axios.post(constants.ROOT_URL + '/api/v1/event', {
          system_id: this.system.id,
          event: "R$EVE_E_Bomba_ON",
          client_device: 'd',
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          console.log(response.data);
          var response_return = [];
          if (response.data.hasOwnProperty("record")) {
            for (var i = 0; i < response.data.record.length; i++) {
              response_return.push({
                date: moment(response.data.record[i].date, "DDMMYYYYhhmmss").add(1, 'h').format('DD/MM/YYYY HH:mm:ss'),
                shunter: "On-line",
                value: response.data.record[i].value
              });
            }
          }
          this.list_events = response_return;
        }, (response) => {
          console.log(response.data)
        })
      },
      // Llegir valors per al graf
      getMonthlyWellPercLevel(masters) {
        var master_id = masters[0].id;
        axios.post(constants.ROOT_URL + '/api/v1/stored_value_master', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[master_id, "R$CAL_NivellBassa.PERC"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyRaftPerc(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["Nivell Bassa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      // Prinf graf
      printMonthlyRaftPerc(data) {
        try {
          //Better to construct options first and then pass it as a parameter
          var options = {
            zoomEnabled: true,
            animationEnabled: true,
            axisX: {
              valueFormatString: "DD/MM/YYYY HH:mm"
            },
            axisY: {
              suffix: "%"
            },
            data: data  // random data
          };

          $("#perc-aigua-bassa").CanvasJSChart(options);
        } catch (e) {
          console.log("Catch");
        }
      },
      // switch case per a canviar el valor de la bomba
      onOffPump(shunt){
        var master = JSON.parse(window.localStorage.getItem('masters'));
        var out = this;
        switch (shunt){
          case "ON_pump":
            swal({
              title: 'Confirmació',
              text: "Està segur que vol engegar la bomba?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                out.forceVariableFunction(master[0].name, "DO4", 1);
              }
            });
            break;
          case "OFF_pump":
            swal({
              title: 'Confirmació',
              text: "Està segur que vol apagar la bomba?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                out.forceVariableFunction(master[0].name, "DO5", 1);
              }
            });
            break;
          case "MAN":
            swal({
              title: 'Confirmació',
              text: "Està segur que col posar el mode manual?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                out.forceVariableFunction(master[0].name, "DO6", 1);
              }
            });
            break;
          case "AUTO":
            swal({
              title: 'Confirmació',
              text: "Està segur que vol posar el mode automàtic?",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                out.forceVariableFunction(master[0].name, "DO6", 0);
              }
            });
            break;
          default:
            break;
        }
      },
      // axios per a cambiar l'estat de la bomba
      forceVariableFunction(device, var_to_change, new_value) {
        axios.post(constants.ROOT_URL + '/api/v1/shunting_action', {
          system_id: this.system.id,
          device: device,
          var_to_change: var_to_change,
          client_device: 'd',
          new_value: new_value
        }).then((response) => {
          console.log(response.data);
        }, (response) => {
          console.log(response.data);
        });
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// PumpShunting.vue?dcb2b19e